




























































































































































































































import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import {
  Configuration,
  SelectedCountry,
  RedCapital,
  TitleTemplateDashboard
} from "@/configuration";
import API from "@/api";
import { isRutValid } from "@/utils";
import { EventBus } from "@/main";
import { mapState } from "vuex";
import { DniTrim } from "@/utils";

@Component({
  computed: { },
  data() {
    return {
        rechazo:false,
        createdBusiness:false,
        otherRegisterBusiness:false,
        solicitudBusiness: false,
        evalBusiness:false,
        amountBusiness:false,
        id_empresa:'',
        origen:'',
        variable:'',
        dni:'',
        laststep:false,
        message: ""
    }
  },
  created(){
        EventBus.$on("rechazo1", (valor:any,origen?:any) => {
          this.$data.rechazo = valor
          this.$data.origen = origen
        });
        EventBus.$on("evalBusiness", (valor:any) => {
          this.$data.evalBusiness = valor
        });
        EventBus.$on("solicitudBusiness", (valor:any, id_empresa:any, origen:any, mensaje:any,rutempresa?:any) => {
          this.$data.solicitudBusiness = valor
          this.$data.id_empresa = id_empresa
          this.$data.origen = origen
          this.$data.message = mensaje
          if(rutempresa){
              this.$data.dni = rutempresa
          }

          // @ts-ignore
          this.ultimopaso(this.$data.id_empresa)
        });
        EventBus.$on("createdBusiness", (valor:any, rutempresa:any,id_empresa:any, origen:any, mensaje:any) => {
          this.$data.createdBusiness = valor
          this.$data.id_empresa = id_empresa
          this.$data.dni = rutempresa
          this.$data.origen = origen
          this.$data.message = mensaje
        });
        EventBus.$on("otherRegisterBusiness", (valor:any) => {
          this.$data.otherRegisterBusiness = valor
        });
        EventBus.$on("amountBusiness", (valor:any) => {
            this.$data.amountBusiness = valor
        })
  },
  methods: {
      creditGarantia(){
          this.$router.push('/panel-facto/solicitar/credito')
      },
      payment(id: number) {
      this.$emit("createPayment", id);
        },
      crear_solicitud(){
          let id = this.$data.id_empresa
          let dni = this.$data.dni
          if(this.$data.origen != "Scoring" && this.$data.origen != "AngloAmerican"){
               this.$router.push({ name: 'pruebas-scoring', params: { etapa: '3' , idempresa: id , dni : dni } })
          }
          if(this.$data.origen == 'Scoring'){
               EventBus.$emit("state_business", this.$data.message, id);
          }
           if(this.$data.origen == 'AngloAmerican') { 
                EventBus.$emit("state_business2", this.$data.message, id);
            }
          this.$data.createdBusiness = false;
      },
      ultimopaso(id){
           API.accion.eleven
            .ultimopaso(id)
            .then((res:any) => {
                this.$data.origen_utp = res.data.message[0].origen;
                this.$data.variable = res.data.message[0].variable;
                this.$data.laststep = true;
            })
            .catch(err => {

            })
      },
      retomar(){
            let id = this.$data.id_empresa
            let step = this.$data.variable.toUpperCase()
            if(this.$data.origen != 'Scoring' && this.$data.origen != 'AngloAmerican'){
                if(step == 'PASO 3'){
                    this.$router.push({ name: 'pruebas-scoring', params: { etapa: '4' , idempresa: id } })
                }
                else if(step == 'PASO 4'){
                    this.$router.push({ name: 'pruebas-scoring', params: { etapa: '5', idempresa: id } })
                }
                else if(step == 'PASO 5'){
                    this.$router.push({ name: 'pruebas-scoring', params: { etapa: '5' , idempresa: id} })
                }
                else if(step == 'PASO 5.1'){
                    this.$router.push({ name: 'pruebas-scoring', params: { etapa: '6' , idempresa: id} })
                }
            }
            if(this.$data.origen == 'Scoring'){
                if(step == 'PASO 3'){
                    let etapa = '4'
                    EventBus.$emit("retomar", etapa, id);
                }
                else if(step == 'PASO 4'){
                    let etapa = '5'
                    EventBus.$emit("retomar", etapa, id);
                }
                else if(step == 'PASO 5'){
                    let etapa = '5'
                    EventBus.$emit("retomar", etapa, id);
                }
                else if(step == 'PASO 5.1'){
                    let etapa = '6'
                    EventBus.$emit("retomar", etapa, id);
                }
            }
            if(this.$data.origen == 'AngloAmerican'){
                if(step == 'PASO 2'){
                    let etapa = '3'
                    EventBus.$emit("retomar2", etapa, id);
                }
                if(step == 'PASO 3'){
                    let etapa = '4'
                    EventBus.$emit("retomar2", etapa, id);
                }
                else if(step == 'PASO 4'){
                    let etapa = '5'
                    EventBus.$emit("retomar2", etapa, id);
                }
                else if(step == 'PASO 4.1'){
                    let etapa = '5'
                    EventBus.$emit("retomar2", etapa, id);
                }
                else if(step == 'PASO 5'){
                    let etapa = '5'
                    EventBus.$emit("retomar2", etapa, id);
                }
                else if(step == 'PASO 5.1'){
                    let etapa = '6'
                    EventBus.$emit("retomar2", etapa, id);
                }
            }
            this.$data.solicitudBusiness = false
      },cerrar_solicitud(){
          let origen =   this.$data.origen
          let id = this.$data.id_empresa
          let mensaje = this.$data.message
          let dni =  this.$data.dni
           let etapa = '3'

          API.closedstateBusiness(this.$data.id_empresa)
          .then((res: any)=>{
              if(origen != 'Scoring' && this.$data.origen != 'AngloAmerican'){
                  this.$router.push({ name: 'pruebas-scoring', params: { etapa: etapa , idempresa: id , dni : dni , mensaje:mensaje } })
              }
              if(this.$data.origen == 'Scoring'){
                    EventBus.$emit("retomar", etapa, id,mensaje);
              } 
              if(this.$data.origen == 'AngloAmerican'){
                   EventBus.$emit("retomar2", 2, id,mensaje);
              }
              
          })
          this.$data.solicitudBusiness = false
          
        },
        addOtherBusiness(){
            let origen =  this.$data.origen
            if(origen != 'Scoring'){
                EventBus.$emit("createnewbusiness", true);
            }
            if(origen == 'Scoring') { 
                EventBus.$emit("newbusiness", true);
            }
            if(origen == 'AngloAmerican') { 
                EventBus.$emit("newbusiness2", true);
            }
            this.$data.createdBusiness = false
      },
      destroy() {
          this.$data.rechazo = false;
          if (this.$data.origen != 'op')
          {
            setTimeout(() => {
                this.$router.push('/panel-facto/solicitante/solicitudes')
            },1000)
          }
          
      }
  },
  components: {
  }
})
export default class AlertSac extends Vue {}
